import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContex } from "../App";
import { ToastContainer, toast } from "react-toastify";
import QRCode from "qrcode.react";
import "react-toastify/dist/ReactToastify.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Profile = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useContext(UserContex);

  const [states, setState] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [data, setData] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [activeTab, setActiveTab] = useState("tickets"); 
  const [editName, setEditName] = useState(false);

  // search/filter states
  const [ticketSearch, setTicketSearch] = useState("");
  const [ticketFilter, setTicketFilter] = useState("all"); // Example filter: all/upcoming/past
  const [membershipSearch, setMembershipSearch] = useState("");
  const [membershipFilter, setMembershipFilter] = useState("all"); // Example filter: active/inactive

  useEffect(() => {
    fetch("/getuserdetail", {
      method: "get",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error) {
          localStorage.clear();
          navigate("/login");
        }
        setState(result.details);
        setName(result.details.name);
        setEmail(result.details.email);
        setPhone(result.details.phone);
      });

    fetch("/findmytickets", {
      method: "post",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setData(result.ticket);
      });

    fetch("/getusermemberships", {
      method: "get",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setMemberships(result.events);
      });
  }, []);

  const postUserUpdate = () => {
    fetch("/updateUserDetails", {
      method: "put",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, email, phone }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) window.location.reload();
      })
      .catch(console.log);
  };

  const Logout = () => {
    localStorage.clear();
    dispatch({ type: "CLEAR" });
    navigate("/");
  };

  // Filtered Tickets
  const filteredTickets = data.filter((ticket) => {
    const matchesSearch = ticket.event.name
      .toLowerCase()
      .includes(ticketSearch.toLowerCase());
    if (ticketFilter === "upcoming") {
      return matchesSearch && new Date(ticket.event.date) >= new Date();
    } else if (ticketFilter === "past") {
      return matchesSearch && new Date(ticket.event.date) < new Date();
    }
    return matchesSearch;
  });

  // Filtered Memberships
  const filteredMemberships = memberships.filter((membership) => {
    const matchesSearch = membership.name
      .toLowerCase()
      .includes(membershipSearch.toLowerCase());
    if (membershipFilter === "active") {
      return matchesSearch && membership.userStatus === "active";
    } else if (membershipFilter === "inactive") {
      return matchesSearch && membership.userStatus !== "active";
    }
    return matchesSearch;
  });

  return (
    <>
      <Header />

      <main className="bg-gray-100 min-h-screen">
        {/* Hero Section */}
        <section className="relative h-72 md:h-96">
          <div
            className="absolute inset-0 md:bg-center bg-bottom bg-cover"
            style={{
              backgroundImage:
                "url('/profilebanner.png')",
            }}
          >
            <span className="absolute inset-0 bg-black opacity-10"></span>
          </div>
        </section>

        {/* Profile Card */}
        <section className="relative -mt-32 container mx-auto px-4">
          <div className="bg-white rounded-xl shadow-lg p-6 flex flex-col md:flex-row items-center md:items-start gap-6">
            {/* Profile Picture */}
            <div className="relative">
              <img
                src={
                  states?.pic ||
                  "https://img.freepik.com/free-vector/user-blue-gradient_78370-4692.jpg"
                }
                alt="Profile"
                className="w-32 h-32 rounded-full border-4 border-white shadow-lg object-cover"
              />
              {/* <button
                onClick={Logout}
                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-2 shadow hover:bg-red-600"
                title="Logout"
              >
              X
              </button> */}
              <button
                onClick={() => setEditName(true)}
                className="absolute -bottom-2 -right-2 bg-purple-500 text-white rounded-full p-2 shadow hover:bg-purple-600"
                title="Edit Name/Info"
              >
                ✎
              </button>
            </div>

            {/* Profile Info */}
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-3xl font-bold text-purple-600">
                {states?.name}
              </h2>
              <p className="text-gray-600">{states?.email}</p>
              <p className="text-gray-600">{states?.phone}</p>
              <div className="flex justify-center md:justify-start mt-4 gap-6">
                <div className="text-center">
                  <p className="font-semibold text-lg text-gray-800">
                    {data?.length || 0}
                  </p>
                  <p className="text-gray-500 text-sm">Tickets</p>
                </div>
                <div className="text-center">
                  <p className="font-semibold text-lg text-gray-800">
                    {memberships?.length || 0}
                  </p>
                  <p className="text-gray-500 text-sm">Memberships</p>
                </div>
              </div>
            </div>
          </div>
             <button
                onClick={Logout}
                className="absolute top-0 right-4   rounded-full p-2  "
                title="Logout"
              >
              <svg class="h-8 w-8 text-red-500"  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />  <path d="M7 12h14l-3 -3m0 6l3 -3" /></svg>
              </button>
        </section>

        {/* Edit Name Modal */}
        {editName && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
              <h3 className="text-xl font-bold text-purple-600 mb-4">
                Edit Profile
              </h3>
              <button
                className="absolute top-3 right-3 text-red-500 text-lg font-bold"
                onClick={() => setEditName(false)}
              >
                ✕
              </button>
              <div className="space-y-4">
                <input
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
                />
                <input
                  type="text"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
                />
                <input
                  type="text"
                  placeholder="Phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
                />
                <button
                  onClick={() => {
                    postUserUpdate();
                    setEditName(false);
                  }}
                  className="w-full bg-purple-600 text-white py-2 rounded-lg hover:bg-purple-700 transition"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Tabs */}
        <section className="container mx-auto mt-10 px-4">
          <div className="flex border-b border-gray-300">
            <button
              onClick={() => setActiveTab("tickets")}
              className={`py-2 px-4 font-semibold ${
                activeTab === "tickets"
                  ? "border-b-2 border-purple-600 text-purple-600"
                  : "text-gray-600 hover:text-purple-600"
              }`}
            >
              Tickets
            </button>
            <button
              onClick={() => setActiveTab("memberships")}
              className={`ml-4 py-2 px-4 font-semibold ${
                activeTab === "memberships"
                  ? "border-b-2 border-purple-600 text-purple-600"
                  : "text-gray-600 hover:text-purple-600"
              }`}
            >
              Memberships
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-6">
            {/* Tickets */}
            {activeTab === "tickets" && (
              <>
                {/* Search & Filter */}
                <div className="flex flex-col md:flex-row gap-4 mb-4">
                  <input
                    type="text"
                    placeholder="Search Tickets..."
                    value={ticketSearch}
                    onChange={(e) => setTicketSearch(e.target.value)}
                    className="border rounded-lg px-4 py-2 flex-1 focus:ring-2 focus:ring-purple-500 focus:outline-none"
                  />
                  <select
                    value={ticketFilter}
                    onChange={(e) => setTicketFilter(e.target.value)}
                    className="border rounded-lg px-4 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
                  >
                    <option value="all">All</option>
                    <option value="upcoming">Upcoming</option>
                    <option value="past">Past</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredTickets.map((item, idx) => (
                    <div
                      key={idx}
                      className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition cursor-pointer"
                    >
                      <img
                        src={item.event?.pic}
                        alt={item.event?.name}
                        className="h-48 w-full object-cover"
                      />
                      <div className="p-4">
                        <h4 className="text-lg font-bold text-gray-800">
                          {item.event?.name}
                        </h4>
                        <p className="text-gray-600">{item.event?.venue}</p>
                        <p className="text-gray-600">
                          Date: {item.event?.date.substring(0, 10)}
                        </p>
                        <p className="text-gray-600">Seat: {item.seat}</p>
                        <div className="flex justify-between items-center mt-3">
                          <span className="text-purple-600 font-bold">
                            ${item.event?.price}
                          </span>
                          <QRCode value={JSON.stringify(item)} size={100} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

          {/* Memberships */}
{activeTab === "memberships" && (
  <>
    {/* Search & Filter */}
    <div className="flex flex-col md:flex-row gap-4 mb-4">
      <input
        type="text"
        placeholder="Search Memberships..."
        value={membershipSearch}
        onChange={(e) => setMembershipSearch(e.target.value)}
        className="border rounded-lg px-4 py-2 flex-1 focus:ring-2 focus:ring-purple-500 focus:outline-none"
      />
      <select
        value={membershipFilter}
        onChange={(e) => setMembershipFilter(e.target.value)}
        className="border rounded-lg px-4 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
      >
        <option value="all">All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {filteredMemberships.map((item) => (
        <div
          key={item._id}
          className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition cursor-pointer"
        >
          <img
            src={item.pic}
            alt={item.name}
            className="h-48 w-full object-cover"
          />
          <div className="p-4">
            <h4 className="text-lg font-bold text-gray-800">{item.name}</h4>
            <p className="text-gray-600">
              Appled At: {item.date.substring(0, 10)}
            </p>
            <p className="text-gray-600">Status: {item.userStatus}</p>
            <a
              href={`singlemembership/${item._id}`}
              className="mt-3 inline-block bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
            >
              Donate Now
            </a>
          </div>
        </div>
      ))}
    </div>
  </>
)}

          </div>
        </section>
      </main>

      <Footer page="profile" />
      <ToastContainer />
    </>
  );
};

export default Profile;
